export default "/images/vendor/flag-icon-css/flags/1x1/cp.svg?3af6cc411f5ef6c15c2cfe12e6644849";